import { render, staticRenderFns } from "./Hualpen.vue?vue&type=template&id=84366a58&"
import script from "./Hualpen.vue?vue&type=script&lang=js&"
export * from "./Hualpen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports